
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    /*
| Developed by Dirupt
| Filename : forgot-password.tsx
| Author : Philippe DESPLATS (philippe@dirupt.com)
*/
import { Box, Typography } from '@mui/material';
import useTranslation from 'next-translate/useTranslation';
import React from 'react';
import * as Yup from 'yup';
import { Form, Formik, FormikHelpers } from 'formik';
import { AxiosError } from 'axios';
import { toast } from 'sonner';
import { AuthEndpoint } from '@/services/api/modules/auth/auth.endpoint';
import { AuthForgotPasswordDto } from '@/services/api/modules/auth/auth.dto';
import { createAuthServerSideProps } from '@/components/ssr/createServerSideProps';
import { SensklePageFactory } from '@/components/ssr/SensklePage';
import { EmailField } from '@/components/formik';
import { Link } from '@/components/common/MLink';
import { UrlsConfig } from '@/config/urls.config';
import { MButton } from '@/components/common/MButton';
import { MDarkModeSwitch } from '@/components/common/MDarkModeSwitch';
import { LangSwitch } from '@/components/common/LangSwitch';
/*
|--------------------------------------------------------------------------
| Constants
|--------------------------------------------------------------------------
*/
const initialValues: AuthForgotPasswordDto = {
    email: '',
};
/*
|--------------------------------------------------------------------------
| Page
|--------------------------------------------------------------------------
*/
const ForgotPasswordPage = SensklePageFactory(() => {
    const { t } = useTranslation();
    const [showConfirmation, setShowConfirmation] = React.useState(false);
    // Form
    // ----------------------------------------------------------------------------
    const validationSchema = React.useMemo(() => {
        return Yup.object().shape({
            email: Yup.string().email().required(),
        });
    }, []);
    // Methods
    // ----------------------------------------------------------------------------
    const handleSubmit = async (values: AuthForgotPasswordDto, formikHelpers: FormikHelpers<AuthForgotPasswordDto>) => {
        try {
            await AuthEndpoint.forgotPassword(values);
            console.log('test');
            setShowConfirmation(true);
        }
        catch (error) {
            if (error instanceof AxiosError) {
                switch (error?.response?.status) {
                    case 429:
                        toast.error(t('common:errors.rateLimit'));
                        break;
                    default:
                        toast.error(t('common:errors.errorOccurred'));
                }
            }
            else {
                toast.error(t('common:errors.errorOccurred'));
            }
            console.log(error);
            setShowConfirmation(false);
        }
        finally {
            formikHelpers.setSubmitting(false);
        }
    };
    // Render
    // ----------------------------------------------------------------------------
    return (<Box display={'flex'} flexDirection={'column'} justifyContent={'center'} gap={4} width={'100%'}>
			<Box textAlign={'center'}>
				<Typography variant={'h1'}>{t('auth/forgot-password:title')}</Typography>
				{!showConfirmation ? <Typography>{t('auth/forgot-password:subTitle')}</Typography> : null}
			</Box>
			{showConfirmation ? (<Box marginTop={2} marginBottom={2}>
					<Typography textAlign={'center'}>{t('auth/forgot-password:successes.emailSent')}</Typography>
				</Box>) : (<Formik<AuthForgotPasswordDto> initialValues={initialValues} onSubmit={handleSubmit} validationSchema={validationSchema}>
					{(formikProps) => (<Form>
							<Box display={'flex'} flexDirection={'column'} gap={2}>
								<EmailField autoFocus/>
								<Box display={'flex'} flexDirection={'column'} gap={1}>
									<MButton variant="contained" type="submit" size={'large'} disabled={formikProps.isSubmitting}>
										{t('auth/forgot-password:submitButton')}
									</MButton>
								</Box>
							</Box>
						</Form>)}
				</Formik>)}
			<Box display={'flex'} flexDirection={'column'} justifyContent={'center'} alignItems={'center'} gap={0.5}>
				<Typography variant={'body2'}>{t('auth/forgot-password:doYouRemember')}</Typography>
				<MButton variant={'text'} component={Link} href={UrlsConfig.auth.login}>
					{t('auth/forgot-password:login')}
				</MButton>
			</Box>
			<Box display={'flex'} justifyContent={'space-between'} gap={2}>
				<MDarkModeSwitch />
				<LangSwitch />
			</Box>
		</Box>);
});
/*
|--------------------------------------------------------------------------
| Configurations
|--------------------------------------------------------------------------
*/
ForgotPasswordPage.layout = 'auth';
export default ForgotPasswordPage;
/*
|--------------------------------------------------------------------------
| Server Side Props
|--------------------------------------------------------------------------
*/
const getServerSideProps = createAuthServerSideProps();

    async function __Next_Translate__getServerSideProps__1a09ebd483d__(ctx) {
      const res = await getServerSideProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/auth/forgot-password',
            loaderName: 'getServerSideProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getServerSideProps__1a09ebd483d__ as getServerSideProps }
  